const validate = {
  methods: {
    async validate () {
      return await this.$refs[this.model.entity].validate()
    },
    performInvalidFields (fieldsRefs) {
      fieldsRefs[Object.keys(fieldsRefs)[0]].$el.scrollIntoView()
    }

  }
}

export default validate
